import { Amplify, type ResourcesConfig } from 'aws-amplify';
import { activePortalRegion } from './portal-regions';

// Configure CORS for API requests
const apiConfig = {
  API: {
    REST: {
      SimplySendApi: {
        endpoint: (activePortalRegion.apiUrl || import.meta.env.VITE_API_GATEWAY_URL),
        region: (activePortalRegion.awsRegion || import.meta.env.VITE_AWS_REGION),
        custom_header: async () => {
          const allowedOrigins = [
            window.location.origin,
            'https://main.simple-send-email-saas.pages.dev'
          ];

          // Get the origin from the request or use the first allowed origin as default
          const requestOrigin = (window.location.origin || allowedOrigins[0]);
          const allowedOrigin = allowedOrigins.includes(requestOrigin)
            ? requestOrigin
            : allowedOrigins[0];

          return {
            'Access-Control-Allow-Origin': allowedOrigin,
            'Access-Control-Allow-Headers': 'Content-Type, Authorization',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Credentials': true,
          };
        }
      },
    },
  },
};

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: (activePortalRegion.userPoolId || import.meta.env.VITE_COGNITO_USER_POOL_ID),
      userPoolClientId: (activePortalRegion.clientId || import.meta.env.VITE_COGNITO_CLIENT_ID),
      loginWith: {
        email: true,
        oauth: {
          domain: (activePortalRegion.oauthDomain || import.meta.env.VITE_COGNITO_OAUTH_DOMAIN),
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [`${window.location.origin}`],
          redirectSignOut: [`${window.location.origin}/sign-in`],
          responseType: 'code' as const
        }
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: {
          required: true,
        },
        given_name: {
          required: true,
        },
        family_name: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
      mfa: {
        status: 'optional' as const,
        totpEnabled: true,
        smsEnabled: false,
      },
      // Required for Amplify USER_AUTH + preferredChallenge WEB_AUTHN
      passwordless: {
        webAuthn: {
          relyingPartyId: window.location.hostname === 'localhost'
            ? 'localhost'
            : (activePortalRegion.id !== 'us' ? 'simplysend.dev' : 'simplysend.email'),
          userVerification: 'required',
        },
      },
    },
  },
  ...apiConfig,
};

Amplify.configure(awsConfig);

export default awsConfig;
